import React from 'react';
import { useDropzone } from 'react-dropzone';
import styles from './DocumentUploadForm.module.scss';

interface DocumentDropzoneProps {
  onDrop: (acceptedFiles: File[]) => void;
  reduxFiles: any[];
  uploading: boolean;
}

const DocumentDropzone: React.FC<DocumentDropzoneProps> = ({ onDrop, uploading }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'] },
    multiple: true,
    disabled: uploading,
  });

  return (
    <div
      {...getRootProps()}
      className={styles.dropzone + (isDragActive ? ' ' + styles.active : '')}
      aria-disabled={uploading}
    >
      <input {...getInputProps()} />
      {isDragActive ? (
        <span>Drop the files here ...</span>
      ) : (
        <span>Drag and drop PDF files here, or click to select files</span>
      )}
    </div>
  );
};

export default DocumentDropzone;
